import React, { useEffect, useRef, useState } from 'react';
import styled from '@cthings.co/styled-components';
import { media } from '@cthings.co/styles-utils';
import { Text, TextType } from '@bit/first-scope.text';

import { colorFetchFDS as colorFetch } from '@cthings.co/styles-utils';
import { useTheme } from '@cthings.co/styled-components';

const ItemsWrapper = styled.div`
  width: 100%;
  max-height: 260px;
  box-sizing: border-box;
  background-color: ${colorFetch('gray5')};
  border-radius: 6px;
  cursor: auto;
  ${media.phone} {
    margin: 16px 0 24px 0;
  }
`;

const ParameterListWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  padding: 12px;
`;

type ParameterListProsp = {
  heightOfList: number;
};

const ParameterList = styled.ul<ParameterListProsp>`
  width: 100%;
  max-height: 210px;
  margin: 0;
  padding: 0;
  overflow-y: ${({ heightOfList }) => (heightOfList > 220 ? 'scroll' : 'auto')};
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 4px;
    background: ${colorFetch('gray4')};
    opacity: 1;
    border-radius: ${({ theme }) => theme.borderRadius.primary};
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${colorFetch('gray3')};
    border-radius: ${({ theme }) => theme.borderRadius.primary};
    position: relative;
    top: 4px;
    right: 4px;
  }
`;

type ParameterItemProsp = {
  isLast: boolean;
};

const ParameterItem = styled.li<ParameterItemProsp>`
  display: flex;
  margin-bottom: ${({ isLast }) => (isLast ? '0' : '12px')};
  cursor: pointer;
  &:hover > span {
    color: ${colorFetch('primary')};
  }
  & > div {
    display: flex;
    align-items: center;
  }
`;

const DeviceSecondaryNameWrapper = styled.div`
  width: 236px;
  ${media.phone} {
    width: 124px;
  }
`;

const DeviceNameWrapper = styled.div`
  display: flex;
  width: 210px;
  ${media.phone} {
    width: 180px;
  }
`;

export interface ValueProps {
  name?: string;
  secondary_name?: string;
  user_name?: string;
  id?: string | number;
}

export const ItemsList = ({
  parameterList,
  languageStrings,
  title,
}: {
  parameterList: ValueProps[];
  languageStrings?: any;
  title?: string;
}) => {
  const theme = useTheme();
  const listRef = useRef<any>(null);
  const { gray1, gray2 } = theme.colors;
  const [heightOfList, setHeightOfList] = useState(0);

  useEffect(() => {
    listRef && listRef.current && setHeightOfList(listRef.current.clientHeight);
  }, []);

  return (
    <>
      <ItemsWrapper
        theme={theme}
        onClick={(e: any) => {
          e.stopPropagation();
        }}
        title={title}
      >
        <ParameterListWrapper>
          {parameterList.length > 0 ? (
            <ParameterList ref={listRef} heightOfList={heightOfList}>
              {parameterList.map((item: any, index: number) => {
                const { name, type } = item;
                return (
                  <ParameterItem key={index} isLast={index === parameterList.length - 1}>
                    <DeviceNameWrapper>
                      <Text type={TextType.TEXT_14_GRAY} color={gray1} weight={'400'} lineHeight={'20px'}>
                        {name}
                      </Text>
                    </DeviceNameWrapper>

                    {type && (
                      <DeviceSecondaryNameWrapper>
                        <Text type={TextType.TEXT_14_GRAY} color={gray2} weight={'400'} lineHeight={'20px'}>
                          {type}
                        </Text>
                      </DeviceSecondaryNameWrapper>
                    )}
                  </ParameterItem>
                );
              })}
            </ParameterList>
          ) : (
            <>
              <Text type={TextType.TEXT_14_GRAY} color={gray2} weight={'400'}>
                {languageStrings.placeholderNoData}
              </Text>
            </>
          )}
        </ParameterListWrapper>
      </ItemsWrapper>
    </>
  );
};
